import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from 'react-router-dom';

import axios from "axios";
import { checkAuthenticated, destroyCredentials } from '../../Actions/userSessionActions';
import { constants } from '../../Helpers/Constants';
import EUSidebar from './EUSidebar';
import { HomeDefault, CalendarDefault, MediaDefault, UserProfile } from '../Common/Buttons/Icons';
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import moment from 'moment';
import FXPLogo from '../Common/FXPLogo';
import { UserAvatarMenu } from '../Common/Menus/UserAvatarMenu';

//A React component will allow us to quickly iterate and change our code. It provides 
class EUNavbar extends Component {
    constructor(props) {
        super(props);

        this.selectLanguage = this.selectLanguage.bind(this);

        this.state = {
        };
    }

    toggleDropdown(id) {
        const element = document.getElementById(id);
        if (!element) return;

        if(element.classList.contains('is-open')) {
            element.classList.remove('is-open');
        } else {
            $('.dropdown-pane').removeClass('is-open');
            element.classList.add('is-open');
        }
    }

    toggleMenu(id) {
        const element = document.getElementById(id);
        if (!element) return;

        element.classList.remove('is-closed');
        element.classList.toggle('is-open');
        element.classList.toggle('is-transition-overlap');
    }

    selectLanguage(language) {
        if (language !== this.props.userSession.user.language) {
            var self = this;

            axios({
                method: 'post',
                url: "ajax/profile/" + this.props.userSession.user.profile_id + "/updateLanguage",
                data: {
                    language
                },
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            })
            .then(function(res) {
                self.props.dispatch(checkAuthenticated())

                if (self.props.userSession.user.user_type === constants.user_type.user) {
                    let language_code = 'en';

                    if (language === "French") {
                        language_code = 'fr'
                    }

                    i18n.changeLanguage(language_code)
                    moment.locale(language_code);
                }
            })
        }
    }

    render() {
        return (
            <>
                <div className="top-bar header eu-nav">
                    <div className = "header-left float-left">
                        <div className = "header-responsive-menu-icon mr-16">
                            <a onClick={()=>this.toggleDropdown('sideMenu')} className = "menu-icon" style={{background: 'white'}}></a>
                        </div>
                        <div className = "header-logo float-left">
                            <Link to = "/home">
                                <FXPLogo/>
                                {/* {
                                    this.props.userSession.user.user_role !== null && this.props.settings.nav_logo !== "images/default-email-logo.png" ?
                                        <img src="images/default-email-logo.png" />
                                    :
                                        <img src="images/default-email-logo.png" />
                                } */}
                            </Link>
                        </div>
                        <ul className = "header-links medium-horizontal menu simple body pl-24">
                            {
                                this.props.userSession.user.user_role !== null ?
                                    <>
                                        <li className = "header-links-li"><Link to = "/home" className = { "header-links-a has-tip" +  ((this.props.match.url).split('/')[1] === "home" ? " menu-active" : "")} >{HomeDefault("fill-primary", "top-bar")}</Link></li>
                                        <li className = "header-links-li"><Link to = "/bookings/current" className = { "header-links-a has-tip" +  ((this.props.match.url).split('/')[1] === "bookings" ? " menu-active" : "")} >{CalendarDefault("fill-primary", "top-bar")}</Link></li>
                                        {
                                            this.props.userSession.user.user_role === constants.user_role.media_influencer ?
                                                <li className = "header-links-li"><Link to = "/eu-media" className = { "header-links-a has-tip" +  ((this.props.match.url).split('/')[1] === "eu-media" ? " menu-active" : "")} >{MediaDefault("fill-primary", "top-bar")}</Link></li>
                                            :
                                                null
                                        }
                                    </>
                                :
                                    null
                            }
                        </ul>
                    </div>
                    <div className = "header-right float-right">
                        <div className = "header-profile-menu menu-right-profile">
                            {
                                this.props.userSession.user.photo && this.props.userSession.user.photo !== "" ?
                                    <div className="button px-32 circle default no-margin image-container" onClick={()=>this.toggleDropdown('eu-menu-dropdown')} style = {{paddingTop:'1px'}}>
                                        <img src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + this.props.userSession.user.photo} className="image-src"/>
                                    </div>
                                :
                                    <a className = "button circle px-32 default no-margin" onClick={()=>this.toggleDropdown('eu-menu-dropdown')} style = {{paddingTop:'1px'}}>
                                        {UserProfile("fill-primary", "top-bar")}
                                    </a>
                            }
                            <div className="dropdown-pane add-pane" id="eu-menu-dropdown" style={{left:"-115px"}}>
                                <UserAvatarMenu
                                    userSession={this.props.userSession}
                                    closeDropdown={() => this.toggleDropdown("eu-menu-dropdown")}
                                    dispatch={this.props.dispatch}
                                    history={this.props.history}
                                    match={this.props.match}
                                />
                            </div>
                        </div>
                        <div className="language-selector">
                            <div onClick={() => this.selectLanguage("English")} className={"language" + (this.props.userSession.user.language === "English" ? " selected" : "")}>EN</div>
                            <div className="break">|</div>
                            <div onClick={() => this.selectLanguage("French")} className={"language" + (this.props.userSession.user.language === "French" ? " selected" : "")}>FR</div>
                        </div>
                    </div>
                </div>

                {
                    window.innerWidth < 769 ?
                        <div className = "eu-nav-sidebar header-side-menu off-canvas position-left" id="sideMenu" style = {{boxShadow:"2px 0px 10px rgba(0,0,0,0.1)",zIndex:"500"}}>
                            <EUSidebar mobile history={this.props.history} match={this.props.match} location={this.props.location}/>
                        </div>
                    :
                        null
                }
            </>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
});

export default connect(mapStateToProps)(EUNavbar);